import React from 'react';
import PropTypes from 'prop-types';
import { PaymentMethodMessagingElement } from '@stripe/react-stripe-js';
import classNames from 'classnames';
import Typography from 'components/base/typography';

const CheckoutAffirmMessage = props => {
  // The minimum comes from the price quote (affirm_minimum), so it lives only in the backend.
  if (props.amountInCents == null || props.currency == null || props.minimum == null) {
    return null;
  }

  const isVisible = props.amount >= props.minimum;

  return (
    <>
      <p
        className={classNames({
          'mt-1': true,
          'd-none': props.hideMinimumAmoutMessage || isVisible,
          [props.className]: props.className,
        })}
      >
        Installment payments powered by Affirm are available on orders of ${props.minimum} or more
        (after discounts, shipping, and taxes)
      </p>
      <div
        className={classNames({
          'd-none': !isVisible,
        })}
      >
        <PaymentMethodMessagingElement
          options={{
            amount: props.amountInCents,
            currency: props.currency,
            paymentMethodTypes: ['affirm'],
            countryCode: 'US',
          }}
          className="transition-none my-1"
        />
        {props.withDescription && (
          <>
            <hr className="mt-2" />
            <div className="d-flex align-items-center">
              <svg
                fill="var(--colorIconRedirect)"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 40"
                role="presentation"
                style={{ width: 40 }}
                className="m-1"
              >
                <path
                  opacity=".6"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 8a4 4 0 014-4h30a4 4 0 014 4v8a1 1 0 11-2 0v-4a2 2 0 00-2-2H4a2 2 0 00-2 2v20a2 2 0 002 2h30a2 2 0 002-2v-6a1 1 0 112 0v6a4 4 0 01-4 4H4a4 4 0 01-4-4V8zm4 0a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 11-2 0 1 1 0 012 0zm29.992 9.409L44.583 20H29a1 1 0 100 2h15.583l-3.591 3.591a1 1 0 101.415 1.416l5.3-5.3a1 1 0 000-1.414l-5.3-5.3a1 1 0 10-1.415 1.416z"
                />
              </svg>
              <Typography.P className="mb-0">
                Click the blue ‘Pay’ button to set up your payments with Affirm.
              </Typography.P>
            </div>
          </>
        )}
      </div>
    </>
  );
};

CheckoutAffirmMessage.propTypes = {
  amount: PropTypes.number,
  minimum: PropTypes.number,
  amountInCents: PropTypes.number,
  currency: PropTypes.string,
  className: PropTypes.string,
  hideMinimumAmoutMessage: PropTypes.bool,
  withDescription: PropTypes.bool,
};

CheckoutAffirmMessage.defaultProps = {
  hideMinimumAmoutMessage: false,
  withDescription: false,
};

export default CheckoutAffirmMessage;
